import { Tenant } from './../../models'
import axios from 'lib/axios'

const basePath = '/api/v3/tenant'

export const TenantServiceV3 = {
  getTenant: async (): Promise<Tenant> => {
    const { data: response } = await axios.get(basePath)
    return response.data
  }
}
